import React, { useContext } from "react";
import {
  BrowserRouter,
  HashRouter,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import TagManager from "react-gtm-module";
import { ReactQueryDevtools } from "react-query/devtools";
import { DefaultTheme, ThemeProvider } from "styled-components";

import axios, { AxiosInterceptor } from "./definitions/axios";
import { PortalProvider } from "./context/portalContext";
import DataContext, { DataProvider } from "./context/dataContext";
import GlobalStyle from "./styles/globalStyles";

import Header from "./components/header";
import Footer from "./components/footer";
import BlogDetails from "./components/individualBlog";
import BlogsPage from "./components/blogs";
import MainBlog from "./components/blogs/mainBlogHero";
import NotFound from "./components/notFound";
import Home from "./pages/home";
import { refreshUser } from "./api/auth";

const light: DefaultTheme = {
  colors: {
    toggleBorder: "#ABB7C4",
    gradient: "linear-gradient(#39598A, #79D7ED)",
    headerBg: "#FFFFFF",
    cardsBg: "#FFFFFF",
    textColor: "#000000",
    pitchBlack: "#000000",
  },
};

function App() {
  const queryClient = new QueryClient();
  const tagManagerArgs = {
    gtmId: "GTM-W59ZRG2",
  };

  TagManager.initialize(tagManagerArgs);

  return (
    <PortalProvider>
      <DataProvider>
        <QueryClientProvider client={queryClient}>
          <AxiosInterceptor>
            <ThemeProvider theme={light}>
              <GlobalStyle />
              <BrowserRouter basename="/blog/">
                <Routes>
                  <Route
                    path="/"
                    element={
                      <>
                        <Header />
                        <Outlet />
                        <Footer />
                      </>
                    }
                  >
                    {/* render all blogs */}
                    <Route
                      index
                      element={
                        <>
                          {/* <MainBlog />
                          <BlogsPage /> */}
                          <Home />
                        </>
                      }
                    />
                    {/* individual blog  */}
                    <Route path="/details/:id" element={<BlogDetails />} />

                    <Route path="*" element={<NotFound page />} />
                  </Route>
                </Routes>
              </BrowserRouter>

              <script
                type="text/javascript"
                id="zsiqchat"
                // strategy="lazyOnload"
                dangerouslySetInnerHTML={{
                  __html: `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "dce98c8cfacba66b840bf260d7854f2a76686ac2881bacccdf4a257213aaa6d5", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.com/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);
                    $zoho.salesiq.ready=function()
                    {
                      $zoho.salesiq.language("ka");
                    }
            `,
                }}
              />
            </ThemeProvider>
          </AxiosInterceptor>

          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </DataProvider>
    </PortalProvider>
  );
}

export default App;
